import { EndorsementServiceType } from "../../domain/services/endorsement-service";
import fetch from "isomorphic-unfetch";
import Endorsement from "../../domain/models/endorsement";
import { parseJsonRes } from "../../utils/parse-res";

export class EndorsementService implements EndorsementServiceType {
  async listEndorsements(): Promise<Endorsement[]> {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WEB_API_URL}/endorsements?_sort=created_at:DESC&_limit=1000`
    );
    const resData = await parseJsonRes(res);
    const endorsements = resData.map((o) => new Endorsement().fromJson(o));
    return endorsements;
  }
}
